var _rect, _rect2, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalValueLogMslpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_10771_44879)",
    fillOpacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833374,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 15.5,
    stroke: "#0D1A16",
    strokeOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3546 18.85H22.7366L23.0214 18.5953C24.8459 16.963 27.4789 16 30.3334 16C33.1878 16 35.8208 16.963 37.6454 18.5953L37.9301 18.85H38.3121H39.9664C40.5905 18.85 41.1907 19.1166 41.6091 19.5796C42.0269 20.0417 42.2303 20.6642 42.1661 21.2843C42.1661 21.2843 42.1661 21.2843 42.1661 21.2844L40.0951 41.2593L39.9807 42.3624H41.0897H44.2478V42.3625L44.2619 42.3623C44.2715 42.3622 44.2809 42.3639 44.2897 42.3674C44.2984 42.371 44.3063 42.3762 44.3129 42.3826C44.3195 42.3891 44.3246 42.3968 44.3281 42.4051C44.3316 42.4134 44.3334 42.4222 44.3334 42.4311C44.3334 42.4401 44.3316 42.4489 44.3281 42.4572C44.3246 42.4655 44.3195 42.4732 44.3129 42.4797C44.3063 42.4861 44.2985 42.4913 44.2897 42.4948L44.2897 42.4948C44.2809 42.4984 44.2715 42.5001 44.2619 42.5L44.2619 42.4999H44.2478H16.419V42.4998L16.4048 42.5C16.3953 42.5001 16.3859 42.4984 16.3771 42.4948L16.0055 43.4208L16.3771 42.4948C16.3683 42.4913 16.3604 42.4861 16.3538 42.4797C16.3473 42.4732 16.3421 42.4655 16.3386 42.4572C16.3351 42.4489 16.3334 42.4401 16.3334 42.4311C16.3334 42.4222 16.3351 42.4134 16.3386 42.4051C16.3421 42.3968 16.3473 42.3891 16.3538 42.3826C16.3604 42.3762 16.3683 42.371 16.3771 42.3675C16.3859 42.3639 16.3953 42.3622 16.4048 42.3623L16.4048 42.3624H16.419H19.5756H20.6846L20.5703 41.2593L18.5008 21.2837C18.5008 21.2836 18.5007 21.2834 18.5007 21.2833C18.437 20.6622 18.6397 20.0411 19.0562 19.5796C19.4767 19.1153 20.0761 18.85 20.7003 18.85H22.3546ZM44.2478 43.4999C44.3896 43.5019 44.5304 43.4757 44.6621 43.4229L44.2478 43.4999Z",
    stroke: "#02B37F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8334 21H28.8334V25.5H24.3334V28.5H28.8334V36H31.8334V28.5H36.3334V25.5H31.8334V21Z",
    fill: "#F2AE00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10771_44879",
    x1: 9.33337,
    y1: 2,
    x2: 60.3334,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalValueLogMslpLight);
export default __webpack_public_path__ + "static/media/totalValueLogMSLPLight.5847a7adb72628413e30b018fe2bf1f1.svg";
export { ForwardRef as ReactComponent };